import React from "react";

const ProfileContext = React.createContext({profile: {}});

export {ProfileContext};
